export enum MicrositeSocialLinkValueType {
  URL = 'URL',
  EMAIL = 'EMAIL',
}
